import {useQuery} from 'react-query'
import {ServiceCategoryEditModalForm} from './ServiceCategoryEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getServiceCategoryById} from '../core/_requests'

const ServiceCategoryEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: service_category,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-service_category-${itemIdForUpdate}`,
    () => {
      return getServiceCategoryById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  if (!itemIdForUpdate) {
    return <ServiceCategoryEditModalForm isServiceCategoryLoading={isLoading} service_category={{id: undefined}} />
  }

  if (!isLoading && !error && service_category) {
    return <ServiceCategoryEditModalForm isServiceCategoryLoading={isLoading} service_category={service_category} />
  }

  return null
}

export {ServiceCategoryEditModalFormWrapper}
